module.exports = __webpack_public_path__ + "media/images/payments/eway-f89db516d163a8a820d64c3868a370b5.svg";